

























































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { HeadersDataTable } from "@/typings/vuetify/vDataTable";
import { CajaChicaSantiagoVV } from "@/typings/store/plugins/easyFirestore/cajaChicasSantiagoVV";
import { ItemsTablaCajaChicasSantiagoVV } from "@/typings/components/cajaChicasSantiagoVV/tabla";
import "@/helpers/extensions";

@Component
export default class TablaCajaChicasSantiagoVV extends Vue {
  @Prop() readonly opciones!: boolean;
  @Prop() readonly search!: string;
  @Prop() readonly cajaChicasSantiagoVV!: Array<CajaChicaSantiagoVV>;
  @Prop() readonly usuario!: string;

  options = { page: 1, itemsPerPage: 7, pageCount: 0 };
  headerProps = { sortIcon: "mdi-chevron-down" };
  footerProps = { itemsPerPageOptions: [5, 10, 15, 25], showFirstLastPage: true, showCurrentPage: true, class: "tabla-caja-gerencial__footer" };

  get headers(): HeadersDataTable {
    return [
      { text: "N°", value: "numero" },
      { text: "Fecha", value: "fecha" },
      { text: "Rut Prov", value: "rutProveedor" },
      { text: "Nombre Prov", value: "nombreProveedor" },
      { text: "Acción", value: "accion" },
      { text: "Ingresos", value: "ingreso" },
      { text: "Egresos", value: "egreso" },
      { text: "Documento", value: "documento" },
      { text: "Concepto", value: "concepto" },
      { text: "Comprobante", value: "tieneComprobante", sortable: true, width: "140" },
      { text: "Descripcion", value: "descripcion" },
      { text: "Acciones", value: "opciones", sortable: false, align: "end", width: "96" },
    ];
  }

  get items(): ItemsTablaCajaChicasSantiagoVV {
    return this.cajaChicasSantiagoVV.map((cajaChicaSantiagoVV) => {
      const ingreso = (parseInt(cajaChicaSantiagoVV.ingreso, 10) || 0).toCurrency({ symbol: "$" }) ?? "0";
      const egreso = (parseInt(cajaChicaSantiagoVV.egreso, 10) || 0).toCurrency({ symbol: "$" }) ?? "0";
      const archivo = cajaChicaSantiagoVV.archivo;
      const tieneComprobante = !!(archivo && typeof archivo === "object" && Object.keys(archivo).length > 0);
      return {
        numero: cajaChicaSantiagoVV.numero,
        fecha: cajaChicaSantiagoVV.fecha,
        saldoActual: cajaChicaSantiagoVV.saldoActual,
        rutProveedor: cajaChicaSantiagoVV.rutProveedor,
        nombreProveedor: cajaChicaSantiagoVV.nombreProveedor,
        accion: cajaChicaSantiagoVV.accion,
        ingreso,
        egreso,
        documento: cajaChicaSantiagoVV.documento,
        concepto: cajaChicaSantiagoVV.concepto,
        descripcion: cajaChicaSantiagoVV.descripcion,
        tieneComprobante,
        data: cajaChicaSantiagoVV,
      };
    });
  }

  getRowClass(item: { numero: number }): string {
    return `tabla-caja-gerencial__row-num-${item.numero}`;
  }

  onTableClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest("td:last-child") || target.closest("button") || target.closest(".v-menu")) return;
    const tr = target.closest("tbody tr");
    if (!tr) return;
    const match = tr.className.match(/tabla-caja-gerencial__row-num-(\d+)/);
    if (!match) return;
    const numero = parseInt(match[1], 10);
    const item = this.items.find((i) => i.numero === numero);
    if (item && item.data) this.onAbrirInfo(item.data);
  }

  @Emit("abrir-info")
  onAbrirInfo(cajaChicaSantiagoVV: CajaChicaSantiagoVV): CajaChicaSantiagoVV {
    return cajaChicaSantiagoVV;
  }

  @Emit("abrir-editar")
  onAbrirEditar(cajaChicaSantiagoVV: CajaChicaSantiagoVV): CajaChicaSantiagoVV {
    return cajaChicaSantiagoVV;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(cajaChicaSantiagoVV: CajaChicaSantiagoVV): CajaChicaSantiagoVV {
    return cajaChicaSantiagoVV;
  }
}
